import { useLayout } from '@/layout/LayoutProvider';
import { Props as ButtonProps, Button as OldButton } from '@storeblocks/button';
import {
  Button as RebrandedButton,
  ButtonProps as RebrandedButtonProps
} from '@storeblocks/rebrand/button';

const getRebrandedButtonVariant = (
  variant: ButtonProps['variant']
): RebrandedButtonProps['variant'] => {
  switch (variant) {
    case 'contained':
      return 'primary';
    case 'outlined':
      return 'secondary';
    case 'text':
      return 'tertiary';
    default:
      return 'primary';
  }
};

const Button = (props: ButtonProps) => {
  const { isRebrand } = useLayout();
  const { children, size, variant } = props;

  const rebrandedButtonProps = {
    ...props,
    size: (size as RebrandedButtonProps['size']) || 'medium',
    variant: getRebrandedButtonVariant(variant)
  };

  return isRebrand ? (
    <RebrandedButton {...rebrandedButtonProps}>{children}</RebrandedButton>
  ) : (
    <OldButton {...props}>{children}</OldButton>
  );
};

export default Button;
